import { CloseOutlined } from '@ant-design/icons'
import { ScreenModel, Gate } from '@hmedia/legenda-ds-api-client'
import { Modal, Select, message } from 'antd'
import { FC, useState } from 'react'
import { useUpdateScreenGateMutation } from './queries'

type Props = {
  visible: boolean
  screen?: ScreenModel
  onClose: () => void
  onSuccess: () => void
}

export const GateAssignmentModal: FC<Props> = ({ visible, screen, onClose, onSuccess }) => {
  const [selectedGate, setSelectedGate] = useState<Gate | null>(screen?.gate || null)

  const updateGateMutation = useUpdateScreenGateMutation(
    () => {
      message.success('GATE hozzárendelés frissítve')
      onSuccess()
    },
    (error) => {
      message.error('Hiba történt a GATE hozzárendelés frissítésénél')
      console.error(error)
    }
  )

  const handleSave = async () => {
    if (!screen) return

    updateGateMutation.mutate({
      screenId: screen.id,
      gate: selectedGate,
    })
  }

  const handleClose = () => {
    setSelectedGate(screen?.gate || null)
    onClose()
  }

  return (
    <Modal
      title={`GATE hozzárendelése - ${screen?.name}`}
      open={visible}
      onCancel={handleClose}
      onOk={handleSave}
      okText="Mentés"
      cancelText="Mégse"
      confirmLoading={updateGateMutation.isLoading}
      closeIcon={<CloseOutlined />}
      maskClosable={false}
    >
      <div style={{ marginBottom: '16px' }}>
        <p>Jelenlegi GATE: <strong>{screen?.gate ? `Kapu ${screen.gate.replace('GATE', '')}` : 'Nincs hozzárendelve'}</strong></p>
      </div>

      <Select
        value={selectedGate}
        onChange={setSelectedGate}
        style={{ width: '100%' }}
        placeholder="Válassz GATE-et"
        options={[
          { value: 'GATE1', label: 'GATE 1' },
          { value: 'GATE2', label: 'GATE 2' },
          { value: 'GATE3', label: 'GATE 3' },
          { value: null, label: 'Nincs hozzárendelve GATE-hez' },
        ]}
      />
    </Modal>
  )
}

export default GateAssignmentModal
